var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysiciansCuttingEdge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.02,
    height: 82.59,
    viewBox: "0 0 62.02 82.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.6,
    cy: 15.43,
    r: 5.17,
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.42,
    cy: 15.43,
    r: 5.17,
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.71 72.59 46.71 47.18 56.6 37.29 56.6 20.6",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "53.76 20.6 53.76 37.15 44.96 47.38 44.96 72.59",
    fill: "none",
    stroke: "#dece59",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "50.91 20.6 50.91 37.01 43.22 47.58 43.22 72.59",
    fill: "none",
    stroke: "#c6b852",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "48.07 20.6 48.07 36.87 41.47 47.79 41.47 72.59",
    fill: "none",
    stroke: "#aea34c",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.23 20.6 45.23 36.73 39.73 47.99 39.73 72.59",
    fill: "none",
    stroke: "#968d45",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.38 20.6 42.38 36.59 37.99 48.19 37.99 72.59",
    fill: "none",
    stroke: "#7d773f",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "39.54 20.6 39.54 36.45 36.24 48.39 36.24 72.59",
    fill: "none",
    stroke: "#656138",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "36.7 20.6 36.7 36.31 34.5 48.59 34.5 72.59",
    fill: "none",
    stroke: "#4d4c32",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "33.85 20.6 33.85 36.17 32.75 48.8 32.75 72.59",
    fill: "none",
    stroke: "#35362b",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.01,
    y1: 20.6,
    x2: 31.01,
    y2: 72.59,
    fill: "none",
    stroke: "#1d2025",
    strokeMiterlimit: 10,
    strokeWidth: 0.43
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "29.27 72.59 29.27 48.85 28.17 36.17 28.17 20.6",
    fill: "none",
    stroke: "#35362b",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.93
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "27.52 72.59 27.52 48.64 25.32 36.31 25.32 20.6",
    fill: "none",
    stroke: "#4d4c32",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "25.78 72.59 25.78 48.43 22.48 36.45 22.48 20.6",
    fill: "none",
    stroke: "#656138",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "24.03 72.59 24.03 48.22 19.64 36.59 19.64 20.6",
    fill: "none",
    stroke: "#7d773f",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "22.29 72.59 22.29 48.02 16.79 36.73 16.79 20.6",
    fill: "none",
    stroke: "#968d45",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "20.55 72.59 20.55 47.81 13.95 36.87 13.95 20.6",
    fill: "none",
    stroke: "#aea34c",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "18.8 72.59 18.8 47.6 11.11 37.01 11.11 20.6",
    fill: "none",
    stroke: "#c6b852",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "17.06 72.59 17.06 47.39 8.26 37.15 8.26 20.6",
    fill: "none",
    stroke: "#dece59",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.31 72.59 15.31 47.18 5.42 37.29 5.42 20.6",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.43,
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.01,
    cy: 5.42,
    r: 5.17,
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.71 72.59 46.71 47.18 56.6 37.29 56.6 20.6",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.01,
    y1: 10.59,
    x2: 31.01,
    y2: 82.59,
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "15.31 72.59 15.31 47.18 5.42 37.29 5.42 20.6",
    fill: "none",
    stroke: "#f6e45f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiciansCuttingEdge);
export default __webpack_public_path__ + "static/media/physiciansCuttingEdge.1be7da4666195d0c382677831ad2f98a.svg";
export { ForwardRef as ReactComponent };